module.exports = __webpack_public_path__ + "img/jp-title.a9e9eea4.png";